// Farbton aus dem Artikelnamen erkennen — geordnete Liste aus dem Original
// (Auftrags-Schnellerfassung, Zeilen 1502–1548), unverändert übernommen:
// spezifisch vor generisch („johannisbeer" vor „rot", „amazonas" vor „grün"),
// Deutsch und Englisch, kalibriert an den 620 Positionen eines echten Auftrags.
// Der erste Treffer gewinnt. Die Reihenfolge ist Teil der Fachlogik und darf
// nicht sortiert oder zusammengefasst werden.
export const COLOR_MAP = [
  // Beeren / Rot- und Lilatöne (vor rot/lila prüfen!)
  [/johannisbeer|currant/i, '#A61E36'], [/brombeer|blackberry/i, '#59254C'],
  [/himbeer|raspberry/i, '#C72C48'], [/kirsch|cherry/i, '#9E1B32'],
  [/sangria/i, '#92000A'], [/burgund|bordeaux/i, '#7B1830'],
  [/ruby|rubin/i, '#9B111E'], [/blood|blut/i, '#8A0303'],
  [/aubergine|eggplant/i, '#580F41'], [/pflaume|plum/i, '#8E4585'],
  [/veilchen|krocus|crocus/i, '#9A6FB0'], [/flieder|lilac/i, '#C8A2C8'],
  [/magenta/i, '#D6219C'], [/pink|fuchsia/i, '#EC4899'], [/rosa|blush/i, '#F4A6C0'],
  [/violett|violet|lila|purple|lavend/i, '#7C3AED'],
  // Blau-/Türkistöne
  [/indigo/i, '#4B0082'], [/riviera/i, '#4A90D9'], [/calypso/i, '#3DBBC2'],
  [/t(ü|u)rkis|turquoise|petrol|teal/i, '#0D9488'], [/cyan|aqua/i, '#0891B2'],
  [/navy|marine/i, '#1E3A8A'], [/ultramarin/i, '#2B3A9E'], [/kobalt|cobalt/i, '#0047AB'],
  [/azur|azure/i, '#2F6FDB'], [/blau|blue|denim/i, '#2563EB'],
  // Grüntöne (Molotow: amazonas, kiwi, wasabi, alge, sumpf, menthol, grashüpfer …)
  [/amazonas|amazon green/i, '#2E6F63'], [/menthol/i, '#98E2C6'], [/mint/i, '#5FD3A5'],
  [/kiwi/i, '#8EE53F'], [/wasabi/i, '#A6C875'], [/avocado/i, '#568203'],
  [/grash(ü|u)pfer|grassh(ü|u)pfer|grasshopper/i, '#7BB661'],
  [/alge\b|algae/i, '#55833E'], [/sumpf|swamp/i, '#5A6B3B'],
  [/camouflage|khaki|hanf|hemp/i, '#78866B'], [/oliv|olive/i, '#6B8E23'],
  [/gr(ü|u)n|green/i, '#16A34A'],
  // Gelb-/Beige-/Brauntöne
  [/vanille|vanilla|creme|cream|ivory|elfenbein/i, '#EFE3B0'],
  [/papyrus/i, '#E8E3CE'], [/marmor|marble/i, '#D8D5CE'],
  [/keramik|ceramic/i, '#C3D6D3'], [/puder|powder/i, '#EFD4CB'],
  [/beige|latte|sand\b/i, '#D9C7A0'],
  [/ocker|ochre|curry|mustard|senf/i, '#C9971C'],
  [/quitte|quince/i, '#C9C11F'], [/zitron|lemon|gelb|yellow/i, '#EAB308'],
  // Orange-/Lachstöne
  [/herbstblatt|autumn leaf/i, '#C46210'], [/sunset/i, '#FF8C42'],
  [/grapefruit/i, '#FF6F61'], [/apricot|aprikose/i, '#FBBF77'], [/peach|pfirsich/i, '#FFB38A'],
  [/lachs|salmon|coral|korall|lobster|hummer/i, '#FF7F50'], [/melone|melon/i, '#FFA94D'],
  [/orange/i, '#F97316'],
  // Rot generisch
  [/karmin|carmine|scarlet/i, '#D32F2F'], [/weintraube|grape\b/i, '#6F2DA8'],
  [/rot\b|red\b/i, '#DC2626'],
  // Brauntöne
  [/milchkaffee|cappuccino|nougat|labrador/i, '#B49A7D'],
  [/espresso|mokka|mocca|mocha/i, '#4E312D'],
  [/braun|brown|schoko|choc|kakao|cocoa|coffee/i, '#8B5E3C'],
  // Grau / Schwarz / Weiß / Metallic
  [/anthrazit|graphit|charcoal/i, '#374151'], [/grau|grey|gray/i, '#9CA3AF'],
  [/schwarz|black/i, '#1F2937'], [/wei(ß|ss)|white/i, '#FFFFFF'],
  [/chrom|chrome|silber|silver/i, '#B8BEC4'], [/gold/i, '#D4AF37'], [/kupfer|copper/i, '#B87333'],
];

/** Erster Treffer aus COLOR_MAP oder null, wenn der Name keine Farbe nennt. */
export function colorOf(title) {
    for (const [re, c] of COLOR_MAP) {
        if (re.test(title)) {
            return c;
        }
    }
    return null;
}
